export default "__VITE_ASSET__BQh9wlZo__"